<script>
  import { useSvelteFlow } from "@xyflow/svelte";

  const { fitView, getZoom, zoomIn, zoomOut } = useSvelteFlow();

  export async function incrementZoom() {
    await zoomIn();
    return Math.round(getZoom() * 100);
  }

  export async function decrementZoom() {
    await zoomOut();
    return Math.round(getZoom() * 100);
  }

  export async function centerGraph() {
    await fitView({ padding: 0.18, maxZoom: 1 });
    return Math.round(getZoom() * 100);
  }
</script>
